// angular
import { Component, Input, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';


@Component({
    selector: 'me-landing-page-proof',
    templateUrl: './landing-page-proof.component.html',
    styleUrls: ['./landing-page-proof.component.scss'],
})

export class MeLandingPageProofComponent implements OnInit {
    @Input() data : any = {};

    constructor(
        public appService: AppService
    ) {
       
    }

    ngOnInit() {
    }
}
